// Generated by openapi-codegen. Do not edit manually.

import * as z from 'zod';

export const v1WebhooksUpdateSchema = z.object({
  webhook: z.object({
    url: z.coerce.string().url().describe("URL to send webhook payloads to (must be HTTPS)").nullish(),
    subscriptions: z.optional(z.array(z.enum(["forecasts:created", "forecasts:updated", "forecasts:deleted", "hours:created", "hours:updated", "hours:deleted", "labels:created", "labels:updated", "labels:deleted", "projects:created", "projects:updated", "projects:deleted"])).describe("List of event types to subscribe to")),
    secret_token: z.coerce.string().describe("Secret token used to sign webhook payloads. The signature will be included in the X-Signature header.").nullish(),
    active: z.boolean().describe("Whether the webhook is active").nullish(),
    custom_headers: z.object({}).describe("Custom HTTP headers to include in webhook requests").nullish(),
  }),
});
